import React from 'react';
import { Stepper, Step, StepButton, Typography, Box, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface NavStatusBarProps {
  steps: string[];
  currentStep: number; // 1-based
  onStepClick?: (step: number) => void;
}

const NavStatusBar: React.FC<NavStatusBarProps> = ({ steps, currentStep, onStepClick }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width:860px)');

  const activeStep = currentStep - 1;
  const isSubmitted = currentStep > steps.length;

  const buttonStyle = {
    color: '#8900e1',
    '&:hover': { color: '#7600c4' },
  };

  return (
    <Box sx={{ width: '100%' }}>
      {isMobile && (
        <Typography
          variant="h6"
          sx={{ textAlign: 'center', mb: 2, fontWeight: 'bold' }}
        >
          {t(`form.steps.${steps[activeStep] ?? steps[steps.length - 1]}`, steps[activeStep] ?? steps[steps.length - 1])}
        </Typography>
      )}
      <Stepper alternativeLabel nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step
            key={label}
            completed={index < activeStep}
            sx={{
              '@media (max-width:430px)': {
                paddingLeft: 0,
                paddingRight: 0,
              },
            }}
          >
            <StepButton
              sx={{
                ...buttonStyle,
                '& .MuiStepLabel-label': {
                  display: isMobile ? 'none' : 'block',
                },
                '& .MuiStepIcon-root.Mui-completed': {
                  color: '#702b9d',
                },
                '& .MuiStepIcon-root.Mui-active': {
                  color: '#8900e1',
                },
              }}
              onClick={() => !isSubmitted && onStepClick && index < activeStep && onStepClick(index + 1)}
              disabled={isSubmitted}
            >
              {!isMobile && t(`form.steps.${label}`, label)}
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default NavStatusBar;
